import UIComponent from "../../common/UIComponent";
import "./index.css";
export default class DefinitionBtn extends UIComponent {

  constructor(elementId, interfaces) {
    super();
    this.elementId = elementId;
    this.interfaces = interfaces;
    this.definitionMap = new Map();
    this.init();
  }

  init() {

    // 清晰度组件容器
    this.definitionComponent = document.createElement("div");
    this.definitionComponent.setAttribute("class", "vhallPlayer-definition-component");
    this.definitionComponent.onmouseleave = this.handleComponentMouseLeave.bind(this);

    // 清晰度按钮
    this.definitionBtn = document.createElement("span");
    this.definitionBtn.setAttribute("class", "vhallPlayer-definitionBtn");
    this.definitionBtn.onclick = this.handleBtnClick.bind(this);
    switch (this.interfaces.getCurrentQuality().def) {
      case "a":
        this.definitionBtn.innerText = "音频";
        break;
      case "same":
        this.definitionBtn.innerText = "原画";
        break;
      default:
        this.definitionBtn.innerText = this.interfaces.getCurrentQuality().def;
        break;
    }

    // 清晰度弹窗容器
    this.definitionListPopup = document.createElement("div");
    this.definitionListPopup.setAttribute("class", "definition-popup");

    // 清晰度列表
    this.definitionListBox = document.createElement("ul");
    this.definitionListBox.setAttribute("class", "definition-list-box");
    this.interfaces.getQualitys().forEach((value, index) => {
      this.definitionItem = document.createElement("li");
      switch (value.def) {
        case "a":
          this.definitionItem.innerText = "音频";
          this.definitionMap.set("音频", value);
          break;
        case "same":
          this.definitionItem.innerText = "原画";
          this.definitionMap.set("原画", value);
          break;
        default:
          this.definitionItem.innerText = value.def;
          this.definitionMap.set(value.def, value);
          break;
      }
      this.definitionItem.onclick = this.handleItemClick.bind(this);

      // 清晰度列表追加
      this.definitionListBox.appendChild(this.definitionItem);
    });

    // 弹窗追加列表
    this.definitionListPopup.appendChild(this.definitionListBox)

    // 组件容器追加按钮
    this.definitionComponent.appendChild(this.definitionBtn);

    // 组件容器追加弹窗
    this.definitionComponent.appendChild(this.definitionListPopup)

    this.appendChild(this.elementId, this.definitionComponent);
  }

  handleComponentMouseLeave() {
    this.definitionBtn.setAttribute("class", "vhallPlayer-definitionBtn")
    this.definitionListPopup.style.display = "none";
    this.definitionListPopup.style.opacity = "0";
  }

  handleBtnClick() {
    this.definitionBtn.setAttribute("class", "vhallPlayer-definitionBtn active")
    this.definitionListPopup.style.display = "block";
    this.definitionListPopup.style.opacity = "1";
  }

  handleItemClick(event) {
    const value = event.target.innerText;
    this.definitionBtn.innerText = value;
    this.definitionBtn.setAttribute("class", "vhallPlayer-definitionBtn")
    this.definitionListPopup.style.display = "none";
    this.definitionListPopup.style.opacity = "0";
    this.interfaces.setQuality(this.definitionMap.get(value));
  }


}